



















import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import { ProxyDelayPropertyType } from '../../../logic/Proxy/ProxyDelayTypes'
import SampleDelayLimit from '../components/SampleDelayLimit.vue'

@Component({
  components: {
    SampleDelayLimit,
  },
  data() {
    return {
      SampleDelayLimit,
    }
  }
})
export default class SampleDelayPropertyType extends Vue {
  @Prop() delay!: ProxyDelayPropertyType

  @Prop() i18n!: i18n

  @Prop() getFormattedTime!: (time: number) => string

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  getPropertyName(id: number): string {
    const property = this.getProperties().find((p) => p.id === id)

    if (property) {
      return property.name ?? property.type
    }

    return this.i18n.t('property_not_found').toString()
  }
}
